var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configData
    ? _c(
        "div",
        { staticClass: "box borderPadding" },
        [
          _vm._v(_vm._s(_vm.configData.val) + " "),
          _c("Tinymce", {
            key: _vm.keyIndex,
            staticStyle: { width: "100%", height: "60%" },
            on: {
              input: function (info) {
                return _vm.tinymceInput(info)
              },
              change: _vm.changeTinymce,
            },
            model: {
              value: _vm.newVal,
              callback: function ($$v) {
                _vm.newVal = $$v
              },
              expression: "newVal",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }